import { apiRequest } from './client'
import type { Label, TaskStatusDef } from './types'

export const labelsApi = {
  list: (projectId?: string) => apiRequest<{ data: Label[] }>('/labels', { query: { projectId } }),

  create: (input: { projectId?: string; name: string; color: string; description?: string; icon?: string; priorityValue?: number }) =>
    apiRequest<{ data: Label }>('/labels', { method: 'POST', body: input }),

  update: (id: string, input: Partial<{ name: string; color: string; description: string; icon: string; priorityValue: number }>) =>
    apiRequest<{ data: Label }>(`/labels/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/labels/${id}`, { method: 'DELETE' }),

  listStatuses: (projectId: string) => apiRequest<{ data: TaskStatusDef[] }>('/labels/statuses', { query: { projectId } }),

  createStatus: (input: { projectId: string; name: string; color?: string; isDone?: boolean }) =>
    apiRequest<{ data: TaskStatusDef }>('/labels/statuses', { method: 'POST', body: input }),

  updateStatus: (id: string, input: Partial<{ name: string; color: string; isDone: boolean; isDefault: boolean }>) =>
    apiRequest<{ data: TaskStatusDef }>(`/labels/statuses/${id}`, { method: 'PATCH', body: input }),

  removeStatus: (id: string) => apiRequest<{ data: { success: boolean } }>(`/labels/statuses/${id}`, { method: 'DELETE' }),

  reorderStatuses: (projectId: string, orderedIds: string[]) =>
    apiRequest<{ data: TaskStatusDef[] }>('/labels/statuses/reorder', { method: 'POST', body: { projectId, orderedIds } }),
}
